var _path, _path2, _path3, _path4;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
var SvgFile = function SvgFile(_ref, ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 17,
    viewBox: "0 0 17 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1.89844 4.49909C1.89844 2.69496 3.36097 1.23242 5.1651 1.23242H11.8318C13.6359 1.23242 15.0984 2.69496 15.0984 4.49909V12.4991C15.0984 14.3032 13.6359 15.7658 11.8318 15.7658H5.1651C3.36097 15.7658 1.89844 14.3032 1.89844 12.4991V4.49909ZM5.1651 2.43242C4.02372 2.43242 3.09844 3.3577 3.09844 4.49909V12.4991C3.09844 13.6405 4.02372 14.5658 5.1651 14.5658H11.8318C12.9732 14.5658 13.8984 13.6405 13.8984 12.4991V4.49909C13.8984 3.3577 12.9732 2.43242 11.8318 2.43242H5.1651Z",
    fill: "#1785FF"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.5651 5.16576C4.5651 4.83438 4.83373 4.56576 5.1651 4.56576L11.8318 4.56576C12.1631 4.56576 12.4318 4.83438 12.4318 5.16576C12.4318 5.49713 12.1631 5.76576 11.8318 5.76576L5.1651 5.76576C4.83373 5.76576 4.5651 5.49713 4.5651 5.16576Z",
    fill: "#1785FF"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.5651 8.49909C4.5651 8.16772 4.83373 7.89909 5.1651 7.89909L11.8318 7.89909C12.1631 7.89909 12.4318 8.16772 12.4318 8.49909C12.4318 8.83046 12.1631 9.09909 11.8318 9.09909L5.1651 9.09909C4.83373 9.09909 4.5651 8.83046 4.5651 8.49909Z",
    fill: "#1785FF"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.5651 11.8324C4.5651 11.501 4.83373 11.2324 5.1651 11.2324L8.49844 11.2324C8.82981 11.2324 9.09844 11.5011 9.09844 11.8324C9.09844 12.1638 8.82981 12.4324 8.49844 12.4324L5.1651 12.4324C4.83373 12.4324 4.5651 12.1638 4.5651 11.8324Z",
    fill: "#1785FF"
  })));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgFile);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "file.85bf8ce42e0fea8189be730775941a2b.svg";